
export function initHomeFootButtons(main: HTMLElement) {

	main.querySelectorAll('[data-part="button"]').forEach(
		(d) => {
			d.addEventListener('click', (e) => {
				window['OJNew'].showFreeCoursePopup();
				e.preventDefault();
			})
		}
	)

}
